var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "data-panel-cube-wrapper",
      class: { "close-setting-panel": !_vm.settingPanelShow },
    },
    [
      _c("div", { staticClass: "data-panel-cube-header" }, [
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.settingPanelShow,
                expression: "settingPanelShow",
              },
            ],
          },
          [_vm._v("数据")]
        ),
        _vm._v(" "),
        _c("i", {
          staticClass: "el-icon-s-unfold self-icon",
          on: { click: _vm.tabPanelCloseOrOpen },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tree-wrapper" },
        [
          _vm.selectItem._id && _vm.settingPanelShow
            ? [
                _c("cube-query", {
                  attrs: { selectItem: _vm.selectItem },
                  on: { "preview-detail": _vm.previewDetail },
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "90%", margin: "6px 5%" },
                  attrs: { placeholder: "请输入字段搜索", size: "mini" },
                  model: {
                    value: _vm.dinFilterStr,
                    callback: function ($$v) {
                      _vm.dinFilterStr = $$v
                    },
                    expression: "dinFilterStr",
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "data-panel-dimension-tree" },
                  [
                    [
                      _vm.selectItem.dataSetId
                        ? _c(
                            "el-collapse",
                            {
                              model: {
                                value: _vm.activeNames,
                                callback: function ($$v) {
                                  _vm.activeNames = $$v
                                },
                                expression: "activeNames",
                              },
                            },
                            _vm._l(_vm.dimensionList, function (el) {
                              return _c(
                                "el-collapse-item",
                                {
                                  key: el.name,
                                  attrs: { title: el.name, name: el.name },
                                },
                                [
                                  _c(
                                    "ul",
                                    { staticClass: "ui-schema-antd-tree" },
                                    [
                                      _c(
                                        "draggable",
                                        {
                                          attrs: {
                                            filter: ".isFilter",
                                            sort: false,
                                            "data-type": "dimension",
                                            group: {
                                              name: "any",
                                              pull: "clone",
                                              put: false,
                                            },
                                            animation: "300",
                                          },
                                          model: {
                                            value: el.list,
                                            callback: function ($$v) {
                                              _vm.$set(el, "list", $$v)
                                            },
                                            expression: "el.list",
                                          },
                                        },
                                        _vm._l(el.list, function (i, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: i.id + "_" + index,
                                              staticClass: "drag-li",
                                              class: {
                                                isFilter: _vm.hasChildren(i),
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "field-tree-left",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field-tree-item-warp",
                                                    },
                                                    [
                                                      _vm.hasChildren(i)
                                                        ? _c("i", {
                                                            staticClass:
                                                              "el-icon-caret-right",
                                                            class: {
                                                              "open-rotate":
                                                                i.isOpen,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.setOpenIcon(
                                                                  i
                                                                )
                                                              },
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "field-tree-text",
                                                          attrs: {
                                                            title: i.name,
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(i.name))]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "ul",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            i.isOpen &&
                                                            _vm.hasChildren(i),
                                                          expression:
                                                            "i.isOpen && hasChildren(i)",
                                                        },
                                                      ],
                                                    },
                                                    [
                                                      _c(
                                                        "draggable",
                                                        {
                                                          attrs: {
                                                            "data-type":
                                                              "dimension",
                                                            sort: false,
                                                            group: {
                                                              name: "any",
                                                              pull: "clone",
                                                              put: false,
                                                            },
                                                            animation: "300",
                                                          },
                                                          model: {
                                                            value: i.children,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                i,
                                                                "children",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "i.children",
                                                          },
                                                        },
                                                        _vm._l(
                                                          i.children,
                                                          function (c, cIndex) {
                                                            return _c(
                                                              "li",
                                                              {
                                                                key:
                                                                  c.id +
                                                                  "_" +
                                                                  cIndex,
                                                                staticClass:
                                                                  "drag-li",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "field-tree-item-warp",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "field-tree-text",
                                                                        attrs: {
                                                                          title:
                                                                            c.name,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            c.name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "ui-schema-antd-tree" },
                        [
                          _c(
                            "draggable",
                            {
                              attrs: {
                                sort: false,
                                "data-type": "dimension",
                                group: {
                                  name: "any",
                                  pull: "clone",
                                  put: false,
                                },
                                animation: "300",
                              },
                              model: {
                                value: _vm.dimensions,
                                callback: function ($$v) {
                                  _vm.dimensions = $$v
                                },
                                expression: "dimensions",
                              },
                            },
                            _vm._l(_vm.dimensions, function (i, index) {
                              return _c(
                                "li",
                                {
                                  key: i.id + "_" + index,
                                  staticClass: "drag-li",
                                  class: { isFilter: _vm.hasChildren(i) },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "field-tree-left" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "field-tree-item-warp",
                                            },
                                            [
                                              _vm.hasChildren(i)
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-caret-right",
                                                    class: {
                                                      "open-rotate": i.isOpen,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setOpenIcon(
                                                          i
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("tip-icon", {
                                                attrs: { attrs: i.attrs },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "field-tree-text",
                                                  attrs: { title: i.name },
                                                },
                                                [_vm._v(_vm._s(i.name))]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                i.isOpen && _vm.hasChildren(i),
                                              expression:
                                                "i.isOpen && hasChildren(i)",
                                            },
                                          ],
                                        },
                                        [
                                          _c(
                                            "draggable",
                                            {
                                              attrs: {
                                                "data-type": "dimension",
                                                sort: false,
                                                group: {
                                                  name: "any",
                                                  pull: "clone",
                                                  put: false,
                                                },
                                                animation: "300",
                                              },
                                              model: {
                                                value: i.children,
                                                callback: function ($$v) {
                                                  _vm.$set(i, "children", $$v)
                                                },
                                                expression: "i.children",
                                              },
                                            },
                                            _vm._l(
                                              i.children,
                                              function (c, cIndex) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: c.id + "_" + cIndex,
                                                    staticClass: "drag-li",
                                                    staticStyle: {
                                                      "padding-bottom": "0",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "field-tree-item-warp",
                                                        staticStyle: {
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                          "margin-bottom":
                                                            "4px",
                                                        },
                                                      },
                                                      [
                                                        _c("tip-icon", {
                                                          attrs: {
                                                            attrs: c.attrs,
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "field-tree-text",
                                                            staticStyle: {
                                                              "margin-left":
                                                                "4px",
                                                            },
                                                            attrs: {
                                                              title: c.name,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(c.name)
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "data-panel-dimension-tree" }, [
                  _c(
                    "ul",
                    { staticClass: "ui-schema-antd-tree" },
                    [
                      _c(
                        "draggable",
                        {
                          attrs: {
                            filter: ".isFilter",
                            "data-type": "measure",
                            sort: false,
                            group: { name: "any", pull: "clone", put: false },
                            animation: "300",
                          },
                          model: {
                            value: _vm.measures,
                            callback: function ($$v) {
                              _vm.measures = $$v
                            },
                            expression: "measures",
                          },
                        },
                        _vm._l(_vm.measures, function (i) {
                          return _c(
                            "li",
                            {
                              key: i.id,
                              staticClass: "drag-li",
                              class: { isFilter: _vm.hasChildren(i) },
                            },
                            [
                              _c("div", { staticClass: "field-tree-left" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "field-tree-item-warp" },
                                      [
                                        _vm.hasChildren(i)
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-caret-right",
                                              class: {
                                                "open-rotate": i.isOpen,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setOpenIcon(i)
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("tip-icon", {
                                          attrs: { attrs: i.attrs },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "field-tree-text",
                                            attrs: { title: i.name },
                                          },
                                          [_vm._v(_vm._s(i.name))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: i.isOpen && _vm.hasChildren(i),
                                        expression:
                                          "i.isOpen && hasChildren(i)",
                                      },
                                    ],
                                  },
                                  [
                                    _c(
                                      "draggable",
                                      {
                                        attrs: {
                                          "data-type": "measure",
                                          sort: false,
                                          group: {
                                            name: "any",
                                            pull: "clone",
                                            put: false,
                                          },
                                          animation: "300",
                                        },
                                        model: {
                                          value: i.children,
                                          callback: function ($$v) {
                                            _vm.$set(i, "children", $$v)
                                          },
                                          expression: "i.children",
                                        },
                                      },
                                      _vm._l(i.children, function (c) {
                                        return _c(
                                          "li",
                                          {
                                            key: c.id,
                                            staticClass: "drag-li",
                                            attrs: { ghostClass: "measure" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "field-tree-item-warp",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "field-tree-text",
                                                    attrs: { title: c.name },
                                                  },
                                                  [_vm._v(_vm._s(c.name))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.settingPanelShow
            ? [
                _c(
                  "div",
                  {
                    staticClass: "jzliu-bi-engine-vertical-text",
                    on: { click: _vm.tabPanelCloseOrOpen },
                  },
                  [_vm._v("数据")]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data-panel-tree-title" }, [
      _c("span", [_vm._v("维度")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data-panel-tree-title" }, [
      _c("span", [_vm._v("度量")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }